import type { GroupedOffer } from '@aviata/platform-client';

import { FeatureLabelKey } from '@/features/search-tickets/config';

import type { OfferDetailsOpenLabel } from './types';

const has = (
  offer: Pick<GroupedOffer, 'features' | 'mergedFeatures'>,
  feature: FeatureLabelKey,
) => offer.features?.[feature]?.value || offer.mergedFeatures?.[feature]?.value;

export function getOfferDetailsOpenLabel(
  offer: Pick<GroupedOffer, 'features' | 'mergedFeatures'>,
  rankingTagsForLabel?: string[],
): OfferDetailsOpenLabel | undefined {
  const recommended = has(offer, FeatureLabelKey.RECOMMENDED);

  let cheapest: boolean;
  let fastest: boolean;

  if (rankingTagsForLabel !== undefined) {
    const tagSet = new Set(rankingTagsForLabel);
    cheapest = tagSet.has('cheapest');
    fastest = tagSet.has('fastest');
  } else {
    cheapest = has(offer, FeatureLabelKey.CHEAPEST);
    fastest = has(offer, FeatureLabelKey.FASTEST);
  }

  if (recommended) {
    return 'recommended';
  }
  if (cheapest && fastest) {
    return 'cheapestfastest';
  }
  if (cheapest) {
    return 'cheapest';
  }
  if (fastest) {
    return 'fastest';
  }
  return undefined;
}
